import { Globe, Rocket } from "lucide-react";

export function Footer() {
  return (
    <footer className="py-6 px-4 border-t mt-auto">
      <div className="container mx-auto flex items-center justify-center space-x-2 text-sm text-muted-foreground">
        <Rocket className="h-4 w-4" />
        <span>Made in Saudi</span>
        <span className="text-primary">|</span>
        <span>Built for the World</span>
        <Globe className="h-4 w-4" />
      </div>
    </footer>
  );
}